import clsx from 'clsx';
import { LogoImage } from '@/assets';

interface AuthCardHeaderProps {
  readonly subtitle: string;
  readonly compact?: boolean;
}

export function AuthCardHeader({ subtitle, compact = false }: AuthCardHeaderProps) {
  return (
    <>
      <div className="flex justify-center">
        <img
          src={LogoImage}
          alt="Marchemy logo"
          className={clsx(
            'w-auto max-w-[min(100%,280px)] object-contain',
            compact ? 'h-9 sm:h-10' : 'h-10 sm:h-12',
          )}
        />
      </div>

      <div className={clsx('text-center', compact ? 'space-y-0.5' : 'space-y-1')}>
        <h1
          className={clsx(
            'font-bold tracking-tight text-gray-900',
            compact ? 'text-xl sm:text-2xl' : 'text-2xl sm:text-3xl',
          )}
        >
          Welcome to Marchemy
        </h1>
        <p
          className={clsx(
            'leading-snug text-gray-600',
            compact ? 'text-xs sm:text-sm' : 'text-sm sm:text-base',
          )}
        >
          {subtitle}
        </p>
      </div>
    </>
  );
}
